import styled from 'styled-components';
import Button from '../../../Button';

export const List = styled.ul`
  padding: 0;
  list-style: none;
  margin: 0;
`;

export const Item = styled.li`
  padding: 0;
  list-style: none;
`;

export const ItemSelectable = styled(Button)`
  border-radius: 0;
  border: none;
  color: #333;
  text-shadow: none;
  width: 100%;
  text-align: left;
  background: transparent;
  transition: background 0.3s ease;
  font-size: 16px;
  font-weight: 400;
  height: auto;
  line-height: normal;
  text-shadow: none;
  position: relative;
  box-sizing: border-box;
  padding: 10px 50px 10px 20px;
  cursor: pointer;

  &:hover {
    background: #ecf2f9 !important;
    text-shadow: none !important;
  }
`;

export const ItemHeader = styled.div`
  font-weight: 600;
  font-size: 14px;
  padding: 10px;
`;
